// src/redux/actions/matchesActions.js

import { loadUserProfile } from "./authActions";

export const setMatches = (matches) => ({
  type: "SET_MATCHES",
  payload: matches,
});

export const setMatchesDonneurOrdre = (matches) => ({
  type: "SET_MATCHES_DONNEUR_ORDRE",
  payload: matches,
});

export const addMatch = (match) => ({
  type: "ADD_MATCH",
  payload: match,
});

export const addMatchDonneurOrdre = (match) => ({
  type: "ADD_MATCH_DONNEUR_ORDRE",
  payload: match,
});

export const selectMatch = (match) => ({
  type: "SELECT_MATCH",
  payload: match,
});

export const selectMatchDonneurOrdre = (match) => ({
  type: "SELECT_MATCH_DONNEUR_ORDRE",
  payload: match,
});

export const markMessagesRead = (matchId) => ({
  type: "MARK_MESSAGES_READ",
  payload: matchId,
});

export const addMessageToMatch = (matchId, message) => ({
  type: "ADD_MESSAGE_TO_MATCH",
  payload: { matchId, message },
});

export const addMessageToMatchDonneurOrdre = (matchId, message) => ({
  type: "ADD_MESSAGE_TO_MATCH_DONNEUR_ORDRE",
  payload: { matchId, message },
});

// ---------- ACTION ASYNCHRONE : RÉCUPÉRER LES LIKES ENVOYÉS ----------
export const fetchMatches = (token) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return async (dispatch) => {
    try {
      const response = await fetch(`${apiUrl}/api/matches`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du chargement des matches");
      }

      dispatch(setMatches(data.matches || []));
      return data.matches;
    } catch (error) {
      console.error("Erreur fetchMatches:", error);
      throw error;
    }
  };
};

export const fetchMatchesDonneurOrdre = (token) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return async (dispatch) => {
    try {
      const response = await fetch(`${apiUrl}/api/matchesDonneurOrdre`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du chargement des matches");
      }

      dispatch(setMatchesDonneurOrdre(data.matches || []));
      return data.matches;
    } catch (error) {
      console.error("Erreur fetchMatches:", error);
      throw error;
    }
  };
};

export const sendMessage = (
  token,
  {
    matchId,
    toUserId,
    typeMessage = "text",
    messageTxt = "",
    file = null
  }
) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  return async (dispatch) => {
    try {
      const formData = new FormData();

      formData.append("idMatch", matchId);
      formData.append("toUserId", toUserId);
      formData.append("typeMessage", typeMessage);

      switch (typeMessage) {
        case "text":
          formData.append("messageTxt", messageTxt);
          break;

        case "image":
          formData.append("imgFile", file);
          break;

        case "document":
          formData.append("docFile", file);
          break;

        case "vocal":
          formData.append("vocalFile", file);
          break;

        default:
          throw new Error("Type de message non supporté");
      }

      const response = await fetch(`${apiUrl}/api/matches/message`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors de l'envoi du message");
      }

      // 🔄 Refresh des messages (ou du match)
      dispatch(fetchMessages(token, matchId));

      return data.message;
    } catch (error) {
      console.error("Erreur sendMessage:", error);
      throw error;
    }
  };
};

export const sendMessageDonneurOrdre = (token, matchId, message, toUserId) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  return async (dispatch) => {
    try {
      // ✅ Préparation du FormData
      const formData = new FormData();
      formData.append("idMatch", matchId);
      formData.append("message", message);
      formData.append("toUserId", toUserId);

      // ✅ Appel API POST
      const response = await fetch(`${apiUrl}/api/matchesDonneurOrdre/message`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors de l'envoi du message");
      }

      // ✅ Ajoute le message au match correspondant dans le store Redux
      dispatch(fetchMatchesDonneurOrdre(token));

      return data.message;
    } catch (error) {
      console.error("Erreur sendMessage:", error);
      throw error;
    }
  };
};
export const fetchMessages = (token, matchId) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return async (dispatch) => {
    try {
      const response = await fetch(`${apiUrl}/api/matches/messages?idMatch=${matchId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du chargement des messages");
      }

      dispatch({
        type: "UPDATE_MATCH_MESSAGES",
        payload: { matchId, messages: data.messages },
      });

      return data.messages;
    } catch (error) {
      console.error("Erreur fetchMessages:", error);
      throw error;
    }
  };
};

export const fetchMessagesDonneurOrdre = (token, matchId) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return async (dispatch) => {
    try {
      const response = await fetch(`${apiUrl}/api/matchesDonneurOrdre/messages?idMatch=${matchId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du chargement des messages");
      }

      dispatch({
        type: "UPDATE_MATCH_MESSAGES_DONNEUR_ORDRE",
        payload: { matchId, messages: data.messages },
      });

      return data.messages;
    } catch (error) {
      console.error("Erreur fetchMessages:", error);
      throw error;
    }
  };
};

